import bankAccConstants from "../constants/bankAccConstants";

const createBankAccDetails = (payload: any) => ({
  type: bankAccConstants.ADD_BANK_ACC_REQ,
  payload,
});

export const editBankAccDetails = (payload: any) => ({
  type: bankAccConstants.EDIT_BANK_ACC_REQUEST,
  payload,
});

export const retrieveBankAccDetails = (payload: any) => ({
  type: bankAccConstants.GET_BANK_ACC_REQUEST,
  payload,
});

export default createBankAccDetails;
